/**
 * PDA seed byte arrays for the Morfi opinion program.
 * Each constant matches the corresponding Rust `b"..."` literal exactly.
 * Used as the first seed component in PDA derivation functions.
 */

/** Seed for Market PDA: b"market" */
export const MARKET_SEED: Uint8Array = new TextEncoder().encode('market');
/** Seed for Outcome Mint PDA: b"outcome_mint" */
export const OUTCOME_MINT_SEED: Uint8Array = new TextEncoder().encode('outcome_mint');
/** Seed for Claim Receipt PDA: b"claim_receipt" */
export const CLAIM_RECEIPT_SEED: Uint8Array = new TextEncoder().encode('claim_receipt');
/** Seed for GiftConfig PDA: b"gift_config" */
export const GIFT_CONFIG_SEED: Uint8Array = new TextEncoder().encode('gift_config');
/** Seed for GiftAdmin PDA (treasury authority): b"gift_admin" */
export const GIFT_ADMIN_SEED: Uint8Array = new TextEncoder().encode('gift_admin');
/** Seed for Gift PDA: b"gift" */
export const GIFT_SEED: Uint8Array = new TextEncoder().encode('gift');

/** Claim rights mint PDA seed: b"claim_rights_mint" */
export const CLAIM_RIGHTS_MINT_SEED: Uint8Array = new TextEncoder().encode('claim_rights_mint');
/** Backer share mint PDA seed: b"backer_share_mint" */
export const BACKER_SHARE_MINT_SEED: Uint8Array = new TextEncoder().encode('backer_share_mint');
/** Platform fee vault PDA seed: b"platform_fee_vault" */
export const PLATFORM_FEE_VAULT_SEED: Uint8Array = new TextEncoder().encode('platform_fee_vault');
/** MPL Token Metadata PDA seed: b"metadata" */
export const METADATA_SEED: Uint8Array = new TextEncoder().encode('metadata');
/** Anchor `#[event_cpi]` authority PDA seed: b"__event_authority" */
export const EVENT_AUTHORITY_SEED: Uint8Array = new TextEncoder().encode('__event_authority');
/** Sell-cap program: per-market cap switch PDA seed: b"sell_cap" */
export const SELL_CAP_SEED: Uint8Array = new TextEncoder().encode('sell_cap');
/** Sell-cap program: per-preset opt-in PDA seed: b"sell_cap_config" */
export const SELL_CAP_CONFIG_SEED: Uint8Array = new TextEncoder().encode('sell_cap_config');
/** Sell-cap program: trader cost-basis position PDA seed: b"position" */
export const POSITION_SEED: Uint8Array = new TextEncoder().encode('position');
